import React from 'react';
import styled from 'styled-components';

import { accent } from '../../../constants/colors';
import { H5Size } from '../../../constants/text';
import { H5 } from '../../texts';
import { SpriteIconFunctional } from '../../common/SpriteIconFunctional';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 32px;
  padding: 6px 10px;
  padding: 5px 10px 7px 10px;
  border: 1px solid ${accent.ocean250};
  background-color: #ebf1f8;

  &:hover {
    background: ${accent.ocean250};
    cursor: pointer;
  }
`;

const Label = styled(H5)`
  line-height: ${H5Size};
  font-weight: 400;
  margin-right: 7px;
`;

const StyleSpriteIconFunctional = styled(SpriteIconFunctional)`
  position: relative;
  top: 2px;
  cursor: pointer;
`;

export const FilterBadge = ({ label, onRemove, ...rest }) => {
  return (
    <Container onClick={onRemove} {...rest}>
      <Label>{label}</Label>
      <StyleSpriteIconFunctional id="Close" size={9} />
    </Container>
  );
};
